const steps = [
  {
    num: "01",
    title: "Place Your Order Online",
    desc: "Select your passport type and timeline at fastpassportcenter.com. A dedicated Helena agent is assigned immediately upon checkout.",
  },
  {
    num: "02",
    title: "Ship Your Documents",
    desc: "Overnight your signed application, photos, and supporting docs to our processing center. We provide a pre-addressed FedEx label.",
  },
  {
    num: "03",
    title: "Expert Review & Submission",
    desc: "Your agent reviews every document for errors, then submits via reserved courier slot — no agency appointment needed.",
  },
  {
    num: "04",
    title: "Daily Status Updates",
    desc: "Track your passport progress in real time. Your agent calls or emails every business day until your passport is approved.",
  },
  {
    num: "05",
    title: "Passport Delivered to Helena",
    desc: "Your completed passport ships overnight directly to your Helena door. Most customers receive it in 2–9 business days.",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">The Process</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            How We Get Your Helena Passport Fast
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-base leading-relaxed">
            From your kitchen table to your hands — no Denver agency trip, no guesswork.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-4">
          {steps.map((step, i) => (
            <div key={i} className="relative flex flex-col items-center text-center">
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[calc(50%+28px)] right-[-calc(50%-28px)] h-0.5 bg-white/10 w-full"></div>
              )}
              <div className="relative z-10 w-16 h-16 flex items-center justify-center rounded-full bg-[#F6C344] mb-5 flex-shrink-0">
                <span className="font-serif font-bold text-[#1A365D] text-lg">{step.num}</span>
              </div>
              <h3 className="font-bold text-white text-sm mb-2 leading-snug">{step.title}</h3>
              <p className="text-white/60 text-xs leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Helena Passport <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}